import { KeyParamsOrigination, ProtocolVersion, } from '@standardnotes/common';
import { pickByCopy } from '@standardnotes/utils';
import { ProtocolVersionForKeyParams } from './ProtocolVersionForKeyParams';
import { ValidKeyParamsKeys } from './ValidKeyParamsKeys';
export class SNRootKeyParams {
    constructor(content) {
        this.content = {
            ...content,
            origination: content.origination || KeyParamsOrigination.Registration,
            version: content.version || ProtocolVersionForKeyParams(content),
        };
    }
    get isKeyParamsObject() {
        return true;
    }
    get identifier() {
        return this.content004.identifier || this.content002.email;
    }
    get version() {
        return this.content.version;
    }
    get origination() {
        return this.content.origination;
    }
    get content001() {
        return this.content;
    }
    get content002() {
        return this.content;
    }
    get content003() {
        return this.content;
    }
    get content004() {
        return this.content;
    }
    get createdDate() {
        if (!this.content004.created) {
            return undefined;
        }
        return new Date(Number(this.content004.created));
    }
    compare(other) {
        if (this.version !== other.version) {
            return false;
        }
        if ([ProtocolVersion.V004, ProtocolVersion.V003].includes(this.version)) {
            return this.identifier === other.identifier && this.content004.pw_nonce === other.content003.pw_nonce;
        }
        else if ([ProtocolVersion.V002, ProtocolVersion.V001].includes(this.version)) {
            return this.identifier === other.identifier && this.content002.pw_salt === other.content001.pw_salt;
        }
        else {
            throw Error('Unhandled version in KeyParams.compare');
        }
    }
    getPortableValue() {
        return pickByCopy(this.content, ValidKeyParamsKeys);
    }
}
